import { useQuery } from 'react-query';
import { getEventsByCourseId } from 'src/common/services/event';
import { QueryKey } from 'src/config/queryKey';
import { courseEventsQueryStaleTime } from 'src/config/cache';
import { useCurrentUserKeyEnhancer } from 'src/common/hooks/useCurrentUserKeyEnhancer';
import { courseEventsQueryInterval } from 'src/config/globals';
import { CourseEvent } from 'src/common/models/event';

export function useCourseEventsQuery(
  courseId?: number,
  initialData?: () => CourseEvent[] | undefined,
) {
  const { key, isAuthenticated } = useCurrentUserKeyEnhancer([QueryKey.CourseEvents, courseId]);

  return useQuery(
    key,
    () => (courseId ? getEventsByCourseId(courseId, isAuthenticated) : undefined),
    {
      enabled: !!courseId,
      staleTime: courseEventsQueryStaleTime,
      refetchInterval: courseEventsQueryInterval,
      initialData,
    },
  );
}
